import { Message } from "./types";

export const ALLOWED_EXTENSIONS = [
  "pdf",
  "png",
  "jpg",
  "jpeg",
  "webp",
  "svg",
  "bmp",
  "ico",
];

export const GREETING_MESSAGE: Message = {
  role: "assistant",
  text: "-Hi, how can I help you today?",
  timeStamp: null,
};

export const ASSISTANT_MESSAGE_CLASSES = [
  "tw-w-fit",
  "tw-max-w-3xl",
  "tw-p-4",
  "tw-rounded",
  "[&_h1]:tw-text-lg",
  "[&_h2]:tw-text-lg",
  "[&>p:first-of-type]:tw-mt-0",
  "[&>p:last-of-type]:tw-mb-0",
  "[&_p]:tw-mx-0",
  "[&_li]:tw-pb-4",
].join(" ");

export const USER_MESSAGE_CLASSES = [
  "tw-w-fit",
  "tw-max-w-3xl",
  "tw-p-4",
  "tw-rounded",
  "tw-bg-gray-200",
  "[&_p]:tw-mx-0",
  "[&_li]:tw-pb-4",
].join(" ");
